import React, { useMemo, useState } from 'react'
import LayoutForm from '../../../containers/layouts/LayoutForm'
import { Alert, Card, CardBody } from 'react-bootstrap'
import { Header } from '../../../components/Containers/Header'
import { Lista, Options } from './components'
import { activarModalGenerico, clearActiveAllergic } from '../../../store/slices/uiSlice'
import { useDispatch } from 'react-redux'
import { ACTIONS, modules, PERMISSIONS } from '../../../constants'
import { toastAdapter } from '../../../plugins'
import {
  useAddAnticoncepcionMutation,
  useUpdateAnticoncepcionMutation
} from '../../../services/rtk-query'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { genericFormSchema } from '../../../utils'
import { ModalAnticoncepcions } from './components/ModalAnticoncepcion'
import { usePermissions } from '../../../hooks'

export const AnticoncepcionsPage = () => {
  const { hasPermission } = usePermissions()
  const dispatch = useDispatch()
  const [action, setAction] = useState(ACTIONS.SAVE)
  const [addAnticoncepcion] = useAddAnticoncepcionMutation()
  const [updateAnticoncepcion] = useUpdateAnticoncepcionMutation()
  const {
    handleSubmit,
    formState: { errors },
    control,
    reset,
    setValue,
    getValues
  } = useForm({
    resolver: yupResolver(genericFormSchema),
    defaultValues: {
      nombre: '',
      id: 0
    }
  })
  const columns = useMemo(
    () => [
      {
        header: 'id',
        accessorKey: 'id'
      },
      {
        header: 'nombre',
        accessorKey: 'nombre'
      },
      {
        header: 'Activo',
        accessorKey: 'activo',
        cell: ({ row: { original } }) =>
          original.activo ? (
            <Alert
              variant="primary"
              className="text-center d-flex justify-content-center align-items-center"
              style={{
                width: '5rem',
                height: '2rem'
              }}
            >
              Si
            </Alert>
          ) : (
            <Alert
              variant="danger"
              className="text-center d-flex justify-content-center align-items-center"
              style={{
                width: '5rem',
                height: '2rem'
              }}
            >
              No
            </Alert>
          )
      },
      {
        header: 'Opciones',
        accessorKey: 'id',
        cell: ({ row: { original } }) => (
          <Options
            cell={original.id}
            activo={original.activo}
            setAction={setAction}
            hasPermission={!hasPermission([PERMISSIONS.WRITE], modules.anticonceptivos)}
          />
        )
      }
    ],
    []
  )
  const handler = () => {
    dispatch(activarModalGenerico())
  }

  const handlerAction = (data) => {
    if (action === ACTIONS.SAVE) return handleSave(data)

    return handleUpdate(data)
  }

  const handleSave = (data) => {
    const { id, ...rest } = data
    toastAdapter.promise({
      promise: addAnticoncepcion(rest).unwrap(),
      successMessage: () => {
        reset()
        setAction(ACTIONS.SAVE)
        dispatch(clearActiveAllergic())
        return 'Anticoncepcion guardada con éxito'
      },
      errorMessage: 'Error al guardar la Anticoncepcion',
      loadingMessage: 'Guardando Anticoncepcion...'
    })
  }

  const handleUpdate = (data) => {
    toastAdapter.promise({
      promise: updateAnticoncepcion({ ...data, id: +getValues('id') }).unwrap(),
      successMessage: () => {
        handleReset()
        return 'Anticoncepcion guardada con éxito'
      },
      errorMessage: 'Error al guardar la Anticoncepcion',
      loadingMessage: 'Guardando Anticoncepcion...'
    })
  }

  const handleReset = () => {
    reset()
    setAction(ACTIONS.SAVE)
    dispatch(clearActiveAllergic())
  }

  return (
    <LayoutForm title="Anticoncepciones">
      <Card className="shadow-none">
        <Header
          title="Anticoncepciones"
          subtitle="Síntomas de Anticoncepcion"
          buttonTitle="Nueva Anticoncepcion"
          handler={handler}
          hasPermission={!hasPermission([PERMISSIONS.WRITE], modules.alteraciones_menstruales)}
        />
        <CardBody>
          <Lista columns={columns} />
        </CardBody>
      </Card>
      <ModalAnticoncepcions
        action={action}
        control={control}
        errors={errors}
        handlerAction={handlerAction}
        handleSubmit={handleSubmit}
        reset={handleReset}
        setValue={setValue}
      />
    </LayoutForm>
  )
}
